import { Routes, Route } from 'react-router-dom';
import Drivers from './operations/Drivers';
import Vehicles from './operations/Vehicles';
import FleetOverview from './operations/FleetOverview';
import AssetTracking from './operations/AssetTracking';
import Audits from './operations/Audits';

const Operations = () => {
  return (
    <div className="space-y-6">
      <Routes>
        <Route path="/" element={<Drivers />} />
        <Route path="/drivers" element={<Drivers />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/fleet" element={<FleetOverview />} />
        <Route path="/assets" element={<AssetTracking />} />
        <Route path="/audits" element={<Audits />} />
      </Routes>
    </div>
  );
};

export default Operations;
